import { FC } from "react";
import { useGetDiscountsWithDetailsQuery } from "src/store/apis/giftcards";
import DiscountCard from "../DiscountCard/DiscountCard";
import NoData from "@Components/NoData/NoData";
import { useDiscountsListing } from "../../context/DiscountsListingContext";
import { DiscountBrandType } from "src/Modules/Discounts/types";
import { useTranslation } from "react-i18next";
import useSharedVoucherShape from "./hooks/useSharedVoucherShape";

const LOADING_PLACEHOLDERS = Array.from({ length: 10 }, (_, i) => ({ code: `discounts-${i}` }));

const DiscountsGrid: FC<{ brands: Pick<DiscountBrandType, "code">[] | DiscountBrandType[]; loading?: boolean }> = ({ brands, loading }) => {
  const { shapeRef, seamRef, src } = useSharedVoucherShape();

  return (
    <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
      {brands.map((brand, i) => (
        <DiscountCard
          key={brand.code}
          {...brand}
          code={loading ? "###" : brand.code}
          loading={loading}
          background={src}
          shapeRef={i === 0 ? shapeRef : undefined}
          seamRef={i === 0 ? seamRef : undefined}
        />
      ))}
    </div>
  );
};

export default function DiscountsList() {
  const { filters } = useDiscountsListing();
  const { i18n } = useTranslation();
  const { isFetching, data, error } = useGetDiscountsWithDetailsQuery({
    ...filters,
    Page: 1,
    PageSize: 100000,
    lang: i18n.language,
  });
  if (isFetching) return <DiscountsGrid brands={LOADING_PLACEHOLDERS} loading />;
  if (error || !data?.length)
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center">
        <NoData />
      </div>
    );

  return <DiscountsGrid brands={data} />;
}
